import { defineComponent as _defineComponent } from 'vue'
import { mergeProps as _mergeProps, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderSlot as _renderSlot, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "checkbox-item__label" }
const _hoisted_2 = ["name", "value", "checked", "disabled"]
const _hoisted_3 = /*#__PURE__*/_createElementVNode("span", { class: "checkbox-item__icon" }, null, -1)
const _hoisted_4 = { class: "checkbox-item__txt" }
const _hoisted_5 = {
  key: 0,
  class: "checkbox-item__sub"
}

import {
  useAttrs,
  withDefaults,
  defineOptions,
} from "vue";
import {
  mapModifires,
  mergeModifires,
  type typeModifires,
} from "@/components/utils/modifires";

interface Props {
  modifires?: typeModifires;
  checked?: boolean;
  value?: string;
  label?: string;
  name?: string;
  disabled?: boolean;
}

export default /*#__PURE__*/_defineComponent({
  ...{
  inheritAttrs: false,
},
  __name: 'checkbox-item',
  props: {
    modifires: { type: [String, Array, Boolean] },
    checked: { type: Boolean },
    value: {},
    label: {},
    name: {},
    disabled: { type: Boolean }
  },
  emits: ["update"],
  setup(__props: any, { emit }) {

const props = __props;




const attrs = useAttrs();


const updateModelValue = (e: Event) => {
  const isChecked = (e.target as HTMLInputElement).checked;
  const getValue = (e.target as HTMLInputElement).value;
  if (attrs.modelValue instanceof Array) {
    let newValue = [...attrs.modelValue];
    if (isChecked) {
      newValue.push(getValue);
    } else {
      newValue = newValue.filter((item) => ![getValue].includes(item));
    }
    emit("update", newValue);
  } else {
    emit("update", isChecked);
  }
};

const changeEvent = (e: Event) => {
  updateModelValue(e);
};

const statusChecked = (): boolean => {
  if (props.checked && true) {
    return true;
  }
  if (typeof attrs.modelValue === "boolean") {
    return attrs.modelValue;
  }
  if (attrs.modelValue instanceof Array) {
    return Object.values(attrs.modelValue).includes(attrs.value);
  }
  return false;
};

const componentClass = () =>
  mapModifires(
    "checkbox-item",
    mergeModifires(props.modifires, props.disabled && "disabled")
  );

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(componentClass())
  }, [
    _createElementVNode("label", _hoisted_1, [
      _createElementVNode("input", _mergeProps({ onChange: changeEvent }, _ctx.$attrs, {
        class: "checkbox-item__input",
        name: _ctx.name,
        type: "checkbox",
        value: _ctx.value,
        checked: statusChecked(),
        disabled: _ctx.disabled
      }), null, 16, _hoisted_2),
      _hoisted_3,
      _createElementVNode("span", _hoisted_4, [
        _createTextVNode(_toDisplayString(_ctx.label) + " ", 1),
        _renderSlot(_ctx.$slots, "default")
      ])
    ]),
    (_ctx.$slots.sub)
      ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
          _renderSlot(_ctx.$slots, "sub")
        ]))
      : _createCommentVNode("", true)
  ], 2))
}
}

})